
import httpClientService from '@/services/httpClientService'
import axios from 'axios'

export const doAsync = (store, { url, mutationType, method = 'get', data = {}, postSuccess = null }) => {
  if (mutationType) {
    store.commit(mutationType.PENDING)
  }

  return new Promise((resolve, reject) => {
    httpClientService.getAPIHttpClient()({method, url, data})
      .then(response => {
        if (mutationType) {
          store.commit(mutationType.PENDING, false)
          if (response && response.hasOwnProperty('data')) {
            store.commit(mutationType.SUCCESS, response.data)
          }
        }
        resolve(response)
      })
      .catch(error => {
        if (mutationType) {
          store.commit(mutationType.PENDING, false)
          // Typically we use the error_description key but for password reset the api can only return an "message" key
          if (error.response) {
            store.commit(mutationType.FAILURE, error.response.data.error_description || error.response.data.message)
            if (error.response.data && error.response.data.error_description && error.response.data.error_description.indexOf('Invalid refresh token (expired):') !== -1) {
              store.dispatch('logout')
              .then(() => {
                window.location.replace('/login')
              })
            }
          }
        }
        reject(error)
      })
  })
}

export const authAsync = (store, { url, mutationType, method = 'get', data = {}, postSuccess = null }) => {
  if (mutationType) {
    store.commit(mutationType.PENDING)
  }

  const AUTHHTTP = axios.create({
    baseURL: `${process.env.API_ROOT}`,
    crossDomain: true,
    withCredentials: true,
    auth: {
      username: process.env.API_USER,
      password: process.env.API_PASS
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })

  console.log('AUTH ASYNC')

  return new Promise((resolve, reject) => {
    AUTHHTTP({method, url, data})
      .then(response => {
        if (mutationType) {
          store.commit(mutationType.PENDING, false)
          store.commit(mutationType.SUCCESS, response.data)
        }
        resolve(response)
      })
      .catch(error => {
        if (mutationType) {
          store.commit(mutationType.PENDING, false)
          // Typically we use the error_description key but for password reset the api can only return an "message" key
          if (error.response) {
            store.commit(mutationType.FAILURE, error.response.data.error_description || error.response.data.error)
          }
        }
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/stores/async-util.js